import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthenticationService } from 'clan-auth';
import { GlobalEventsService } from '../services/global-events.service';

const HEALTH_METRICS_ENDPOINT = '/metrics/health';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(
        private authenticationService: AuthenticationService,
        private globalEventsService: GlobalEventsService
    ) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (request.url.endsWith(HEALTH_METRICS_ENDPOINT)) {
            return next.handle(request);
        }
        
        this.globalEventsService.setIsAuthenticated(this.authenticationService.isValid());

        return next.handle(request);
    }
}
